import { operationLinkOptionsSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { OperationLinkOptions } from '../../model/operation-link.js';
import type { OperationLinkOptionsDto } from '../dto/operation-link-options.dto.js';
import { toOperationLinkOptions } from '../mappers/operation-link-options.mapper.js';

const fetchOperationLinkOptions = async (
  operationId: string,
  signal: AbortSignal,
): Promise<OperationLinkOptionsDto> =>
  operationLinkOptionsSchema.parse(
    await apiRequest<unknown>(`/bank/transactions/${operationId}/link-options`, { signal }),
  );

export const getOperationLinkOptions = async (
  operationId: string,
  signal: AbortSignal,
): Promise<OperationLinkOptions> =>
  toOperationLinkOptions(await fetchOperationLinkOptions(operationId, signal));
